import { useEffect, useRef } from 'react'
import type { GaFormEventTypeModel, GaFormVisibilityModel } from '../types'
import type { GaFormProps } from './GaForm'

interface Props extends GaFormProps {
  pushToDataLayer: (model: GaFormEventTypeModel) => void
}

const visibilitySentForms = new Set<string>()

export const useFormVisibility = (props: Props) => {
  const { pushToDataLayer } = props
  const hasVisibilitySent = useRef(false)

  useEffect(() => {
    const formKey = `${props.formName}-${props.formLocation}`

    if (hasVisibilitySent.current || visibilitySentForms.has(formKey)) return

    hasVisibilitySent.current = true
    visibilitySentForms.add(formKey)

    const model: GaFormVisibilityModel = {
      formName: props.formName,
      formLocation: props.formLocation,
      event: 'formVisibility',
    }
    pushToDataLayer(model)
  }, [])
}
